export default __webpack_public_path__ + "static/media/leftSemiCircle.afd1069d.svg";